import { useParams } from "react-router-dom";

export const useScheduleCreatePageParams = () => {
  const { siteSlug = "" } = useParams();

  return { siteSlug };
};
